import React, { useEffect, useRef } from 'react';

export default function LoadMoreLoader(props) {

	const {
		next,
		hasMore = false
	} = props;

	const observerTarget = useRef(null);
	
	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting) {
					if (hasMore) {
						next(true)
					}
				}
			},
			{ threshold: 1 }
		);

		if (observerTarget.current) {
			observer.observe(observerTarget.current);
		}

		return () => {
			if (observerTarget.current) {
				observer.unobserve(observerTarget.current);
			}
		};
	}, [observerTarget, hasMore]);

	return (
		<div className="col-12">
			{hasMore && <div className="text-center py-5 mb-3">
				<div className="spinner-border text-secondary" role="status">
					<span className="sr-only">Loading...</span>
				</div>
			</div>}
			<div ref={observerTarget}></div>
		</div>
	);
}